import { useEntityAPI } from '../../../redux/entity-api.hook';
import { serviceStepAPI } from '../redux/service-steps.slice';

export function useServiceSteps() {
  return useEntityAPI(serviceStepAPI);
}
